import { render, staticRenderFns } from "./achievements-card.vue?vue&type=template&id=240cb94d&scoped=true"
import script from "./achievements-card.vue?vue&type=script&lang=js"
export * from "./achievements-card.vue?vue&type=script&lang=js"
import style0 from "./achievements-card.vue?vue&type=style&index=0&id=240cb94d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240cb94d",
  null
  
)

export default component.exports